import { DecimalPipe, LowerCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { PurchaseVehicle } from '@app/sale-presentation/models/purchase-vehicle.model';
import { VehicleIcon } from './vehicle-icon.model';

@Component({
	selector: 'ui-icon-list',
	templateUrl: './icon-list.component.html',
	styleUrls: ['./icon-list.component.less'],
})
export class UIIconListComponent implements OnInit {
	@Input() vehicle: PurchaseVehicle;

	public icons: VehicleIcon[] = [];

	constructor(private lowercasePipe: LowerCasePipe, private decimalPipe: DecimalPipe) {}

	ngOnInit(): void {
		const sale_type: string = this.vehicle.sale_type || 'car';
		const is_electric: boolean = this.vehicle.fuel_type.toUpperCase() === 'ELECTRIC';

		this.icons.push(...this.getSharedIcons());

		if (sale_type === 'car' || sale_type === 'van') {
			this.icons.push(...this.getCarAndVanIcons());

			if (is_electric) {
				this.icons.push(...this.getElectricCarVanIcons());
			}  else {
				this.icons.push(...this.getStandardCarVanIcons());
			}
		}

		if (sale_type === 'van') {
			this.icons.push(...this.getVanIcons());
		}

		if (sale_type === 'car') {
			this.icons.push(...this.getCarIcons());
		}

		if (sale_type === 'bike') {
			this.icons.push(...this.getBikeIcons());
		}
	}

	getSharedIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-mileage',
				value: this.vehicle.mileage !== null ? this.decimalPipe.transform(this.vehicle.mileage, '1.0-0') : '-',
			}),
			new VehicleIcon({
				class_name: 'icon-calendar',
				value: this.vehicle.year !== null ? this.vehicle.year.toString() : '-',
			}),
		];
	}

	getCarAndVanIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-fuel',
				value: this.vehicle.fuel_type !== null ? this.lowercasePipe.transform(this.vehicle.fuel_type) : '-',
			}),
		];
	}

	getVanIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-van',
				value: this.vehicle.body !== null ? this.lowercasePipe.transform(this.vehicle.body) : '-',
			}),
		];
	}

	getCarIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-door',
				value: this.vehicle.doors !== null ? this.vehicle.doors + ' doors' : '-',
			}),
		];
	}

	getBikeIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-motorbike',
				value: this.vehicle.body !== null ? this.lowercasePipe.transform(this.vehicle.body) : '-',
			}),
			new VehicleIcon({
				class_name: 'icon-engine-cc',
				value: this.vehicle.engine_cc !== null ? this.vehicle.engine_cc + ' cc' : '-',
				capitalize: false,
			}),
		];
	}

	getElectricCarVanIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'fa-regular fa-car-battery',
				value: this.vehicle.battery_range ? this.decimalPipe.transform(this.vehicle.battery_range, '1.0-0') + ' mi' : '-',
			}),
			new VehicleIcon({
				class_name: 'fa-regular fa-charging-station',
				value: this.vehicle.battery_fast_charge_time !== null ? this.vehicle.battery_fast_charge_time + ' fast charge' : '-',
			}),
		]
	}

	getStandardCarVanIcons(): VehicleIcon[] {
		return [
			new VehicleIcon({
				class_name: 'icon-engine',
				value: this.vehicle.engine_l ? this.decimalPipe.transform(this.vehicle.engine_l, '1.1-1') + 'l' : '-',
			}),
			new VehicleIcon({
				class_name: 'icon-transmission',
				value: this.vehicle.gearbox !== null ? this.lowercasePipe.transform(this.vehicle.gearbox) : '-',
			}),
		];
	}
}
